import { useContext, useMemo } from 'react';
import { Dashboard, DashboardJson } from '../modules/models';
import { DashboardContext } from './DashboardContext';
import { findTemplateByName } from '../utils/templateUtils';

export const useDashboardJson = ({ name = '' }: DashboardJson): DashboardJson | undefined => {
  const { TemplateRegistry } = useContext(DashboardContext);
  const json = useMemo(() => findTemplateByName(TemplateRegistry, name), [TemplateRegistry, name]);
  return json;
};

export const useDashboard = ({ name = '', raw = false }: DashboardJson): Dashboard | DashboardJson | undefined => {
  const json = useDashboardJson({ name });
  if (raw) {
    return json;
  }
  return new Dashboard(json as DashboardJson);
};
